<template>
  <div class="online-courses-page">
    <div class="heading">
      <h1>Terms and Conditions</h1>
    </div>

    <div class="terms-container">
      <h1 class="title">Azadi Academy Terms and Conditions</h1>
      <p class="effective-date">Effective Date: January 26th, 2025</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing Azadi Academy’s website, courses, or other materials, you
          confirm that you have read, understood, and agree to these terms and
          conditions. If you do not agree, you may not participate in the
          academy’s programs.
        </p>
      </section>

      <section>
        <h2>2. Eligibility</h2>
        <p>
          Participation in Azadi Academy is open to individuals who meet the
          following criteria:
        </p>
        <ul>
          <li>
            You are at least 18 years old or have parental/guardian consent if
            under 18.
          </li>
          <li>You have a valid email address for communication.</li>
          <li>You comply with all applicable laws and regulations.</li>
        </ul>
        <p>
          Any violation of our Terms & Conditions may result in your access to
          all or part of the Services being suspended, disabled, or terminated.
        </p>
      </section>

      <section>
        <h2>3. Content and Intellectual Property</h2>
        <p>
          All content provided by Azadi Academy, including videos, articles, and
          materials, is the intellectual property of Azadi Coin and its
          affiliates.
        </p>
        <p>
          You may not reproduce, distribute, or share academy content without
          explicit written permission.
        </p>
        <p>
          Content is for educational purposes only and should not be construed
          as financial or investment advice.
        </p>
      </section>

      <section>
        <h2>4. Registration and Account Security</h2>
        <p>
          You are responsible for maintaining the confidentiality of your
          account and login credentials. You agree to provide accurate and
          current information during the registration process. Azadi Academy
          reserves the right to suspend or terminate accounts found to be in
          violation of these terms.
        </p>
      </section>

      <section>
        <h2>5. Code of Conduct</h2>
        <ul>
          <li>
            Engage respectfully in discussions and forums on our channels.
          </li>
          <li>Avoid sharing false, harmful, or defamatory content.</li>
          <li>Abide by the guidelines provided for each course or activity.</li>
        </ul>
      </section>

      <section>
        <h2>6. Fees and Payments</h2>
        <p>
          Some courses or services may require payment. Fee details will be
          provided before enrollment. Payments are non-refundable unless
          specified otherwise. If the user mistakenly sends a payment to another
          address, we are not responsible for it.
        </p>
      </section>

      <section>
        <h2>7. Disclaimers and Limitation of Liability</h2>
        <p>
          Azadi Academy provides educational content “as is” without warranties
          of any kind.
        </p>
        <p>
          Azadi Coin and its affiliates are not liable for any decisions or
          actions taken based on academy content.
        </p>
        <p>
          Participants are responsible for their own investment and financial
          decisions.
        </p>
      </section>

      <section>
        <h2>8. Privacy Policy</h2>
        <p>
          Azadi Academy respects your privacy. Any personal information
          collected will be used in accordance with our Privacy Policy.
        </p>
      </section>

      <section>
        <h2>9. Modifications to Terms</h2>
        <p>
          Azadi Academy reserves the right to modify these terms and conditions
          at any time. Participants will be notified of significant changes via
          email or platform announcements.
        </p>
      </section>

      <section>
        <h2>10. Governing Law</h2>
        <p>
          These terms and conditions are governed by the laws of IFZA, Dubai.
          Any disputes shall be resolved in accordance with local regulations.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>
          For any questions or concerns regarding these terms, please contact us
          at: <a href="mailto:info@azadicoin.com">info@azadicoin.com</a>
        </p>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: "TermsAndConditionsPage",
};
</script>

<style scoped>
.terms-container {
  max-width: 65rem;
  margin: 0 auto;
  padding: 2rem;
  background-color: #0e1332;
  border-radius: 1rem;
  font-family: Arial, sans-serif;
  color: #fff;
  font-family: 'Gothic';
}

.title {
  font-family: 'GothicB';
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.effective-date {
  font-style: italic;
  margin-bottom: 1rem;
}

section {
  margin-bottom: 1.5rem;
}

h2 {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-family: 'GothicB';
}

p {
  line-height: 1.6;
}

ul {
  list-style-type: disc;
  margin-left: 1.5rem;
}

ul li {
  margin-bottom: 0.5rem;
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
.heading {
  background-color: #0e1332;
}
.heading h1 {
  padding: 3rem 1.5rem;
  max-width: 65rem;
  margin: 0 auto 2rem;
  color: #fff;
  text-align: center;
  font-family: 'GothicB';
  line-height: 4rem;
}
</style>
